/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABIklEQVR4nN2UQUoDQRBFW1HRC3iduUCqfo2hUzUiZDdXcDkHUARduRfiQg/iCdyoUfEGIqILibQIKtNJxkzPQj/U9r3u6qp27l/He78G6DbBTllsTLDnUAy9YeiI84GVZbm6ELyHok/QBxabzKl7ZuPG4Kqqlgl62AA8+V4keuCcW5orYNGj38L5p2R6SGywKJw/q4dCovBsOFz/6GdLAcGuw3DUBGFa2sL56xb9WO/PUwkYOooIbJxKQLDLmOAlmUDssT5BsNdOBRzWv8sWkehZp49MYkW6FulWTRCWg8RuO1u0EILuJjg9XCx5vrOZ4KH3onDv/QaJXrSD6/7U75pEj1tMzB1QkJuVcDWCvjU86ROLXTH0hHP1WZatzIT/+bwDN8qh9gTxd9sAAAAASUVORK5CYII=)
 */
export const ChatIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 22a10 10 0 1 0-8.45-4.64c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12Z"
        className={colorClass}
      />
    </svg>
  );
};
